import { render, staticRenderFns } from "./sectionVenue.vue?vue&type=template&id=3d258280&scoped=true&"
import script from "./sectionVenue.vue?vue&type=script&lang=js&"
export * from "./sectionVenue.vue?vue&type=script&lang=js&"
import style0 from "./sectionVenue.vue?vue&type=style&index=0&id=3d258280&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d258280",
  null
  
)

export default component.exports